module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-31-896e6f7626a77c7944bbfeab28c65c2c.svg";